import React, { use, useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { extractDate } from "../../../Components/Functions/date.fun";
import { FcCamcorderPro } from "react-icons/fc";
import { useSelector } from "react-redux";
import SimpleButton from "../../../Components/layouts/simple_button";

const ViewDriveDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("reader");
  const [isValid, setIsValid] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Simple email regex validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(emailRegex.test(value));
  };
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/farmmediadrive/folder-details/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting application!");
        }

        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handleSelectEmployee = (item) => {
    setSelectedEmployees((prev) =>
      prev.find((emp) => emp.id === item.id)
        ? prev.filter((emp) => emp.id !== item.id)
        : [...prev, item]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedEmployees(data?.clientsForThisFTDate || []);
    } else {
      setSelectedEmployees([]);
    }
  };

  const handelSubmit = (type = "") => {
    let values = {
      email: type ? email : selectedEmployees,
      folderId: id,
      role: type ? role : "reader",
    };
    const modalEl = type
      ? document.getElementById("close-m2")
      : document.getElementById("close-m");
    modalEl.click();
    setLoading(true);
    performRequest("POST", "/farmmediadrive/share-folder", values)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Send  Data Successfully!");
          if (type) {
            setEmail("");
            setRole("reader");
          }
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  const deleteFile = async (fileId, type = "") => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this file?"
    );
    if (!confirmed) return;

    setLoading(true);
    performRequest("DELETE", `/farmmediadrive/moveto-trash/${fileId}`)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", res.data.message);
          if (type) {
            navigate("/get-folders");
          } else {
            setRefresh(!refresh);
          }
        } else {
          Toast("error", "Error while deleting file!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  const removeAccess = async (fileId, email) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this user access?"
    );
    if (!confirmed) return;

    setLoading(true);
    performRequest("POST", `/farmmediadrive//remove-access/`, {
      folderId: fileId,
      email,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "User access removed successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while removing access!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCamcorderPro className="fs-2 me-1" />
                  Farm Training Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header d-flex justify-content-end">
              {/* <div>
                <h2 className="page-title">View Farm Taraning Details</h2>
              </div> */}

              <div>
                <button
                  className="btn btn-success ms-1 me-1"
                  data-bs-toggle="modal"
                  data-bs-target="#send-media"
                  onClick={() => {
                    let newSelected = [];
                    data?.clientsForThisFTDate?.forEach((item) => {
                      if (!item.hasAccess) {
                        newSelected.push(item);
                      }
                    });
                    setSelectedEmployees(newSelected);
                  }}
                  // style={{ display: "none" }}
                  id="openmodel"
                >
                  Share to All F.T. Clients
                </button>
              </div>

              <div>
                <button
                  className="btn btn-success ms-1 me-1"
                  data-bs-toggle="modal"
                  data-bs-target="#send-media-single"
                  // style={{ display: "none" }}
                  id="openmodel2"
                >
                  Send via Email
                </button>
              </div>

              <div>
                <button
                  className="btn btn-primary ms-1 me-1"
                  onClick={() => {
                    navigate(`/upload-folder/${id}`);
                  }}
                >
                  UPLOAD MEDIA
                </button>
              </div>
              <div>
                <button
                  className="btn btn-danger ms-1"
                  onClick={() => deleteFile(id, "delete-folder")}
                >
                  Delete Folder
                </button>
              </div>
            </div>
            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Folder Name :</label>
                  <div className="w-100 col">{data?.folder?.name}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Folder Id :</label>
                  <div className="w-100 col">{data?.folder?.id}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Web View Link :
                  </label>
                  <div className="w-100 col">
                    <a
                      href={data?.folder?.webViewLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        maxWidth: 200,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {data?.folder?.webViewLink}
                    </a>
                  </div>
                </div>
              )}
            </div>
            {data?.accessUsers?.length > 0 && <hr className="m-0 p-0"></hr>}
            <h2 className="p-3">Access Users</h2>
            {data?.accessUsers?.length > 0 && <hr className="m-0 p-0"></hr>}
            <div className="p-3">
              <div className="table-responsive">
                {data?.accessUsers?.length > 0 && (
                  <table className="table table-vcenter border">
                    <thead>
                      <tr>
                        <th>Sr</th>
                        <th>Email Address</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.accessUsers?.map((lineItem, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              {(lineItem?.emailAddress || "N/A").toUpperCase()}
                            </td>
                            <td>
                              {(lineItem?.displayName || "N/A").toUpperCase()}
                            </td>
                            <td>{(lineItem?.role || "N/A").toUpperCase()}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() =>
                                  removeAccess(id, lineItem?.emailAddress)
                                }
                              >
                                Remove Access
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
            {data?.files?.length > 0 && <hr className="p-0 m-0"></hr>}
            <h2 className="p-3">Files Details</h2>
            {data?.files?.length > 0 && <hr className="p-0 m-0"></hr>}
            <div className="p-3">
              <div className="table-responsive">
                {data?.files?.length > 0 && (
                  <table className="table table-vcenter border">
                    <thead>
                      <tr>
                        <th>Sr</th>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Web Link</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.files?.map((lineItem, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{(lineItem?.id || "N/A").toUpperCase()}</td>
                            <td>{(lineItem?.name || "N/A").toUpperCase()}</td>
                            <td>
                              <a
                                href={lineItem?.webViewLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  maxWidth: 200,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {lineItem?.webViewLink}
                              </a>
                            </td>
                            <td className="d-flex gap-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    lineItem.webViewLink
                                  );
                                }}
                              >
                                Copy
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deleteFile(lineItem.id)}
                              >
                                Delete File
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
          <div
            className="modal modal-blur fade"
            id="send-media"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Select Users from - {data?.folder?.name}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    id="close-m"
                  ></button>
                </div>

                <div className="p-3">
                  <table className="table table-bordered table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Sr</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact No</th>
                        {/* <th>Action</th> */}
                        <th style={{ width: "50px" }}>
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            checked={
                              selectedEmployees.length ===
                              (data?.clientsForThisFTDate || []).length
                            }
                            style={{ height: "20px", width: "20px" }}
                          />
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {(data?.clientsForThisFTDate || []).map((item, index) => (
                        <tr
                          key={item.id || index}
                          className={`${item.hasAccess ? "bg-green-lt" : ""}`}
                        >
                          <td>{index + 1}</td>
                          <td>{item?.name}</td>
                          <td>{item?.email}</td>
                          <td>{item?.watsapppNumber || item?.contactNumber}</td>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedEmployees.some(
                                (emp) => emp.id === item.id
                              )}
                              onChange={() => handleSelectEmployee(item)}
                              style={{ height: "20px", width: "20px" }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Selected count */}
                  <div className="mt-2 text-muted">
                    Selected: {selectedEmployees.length}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!selectedEmployees.length}
                    onClick={() => handelSubmit()}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal modal-blur fade"
            id="send-media-single"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Share Folder via Email</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    id="close-m2"
                  ></button>
                </div>

                <div className="p-3">
                  <label htmlFor="email" className="form-label">
                    Recipient Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Enter valid email"
                  />
                </div>
                <div className="p-3">
                  <label htmlFor="email" className="form-label">
                    Recipient Role
                  </label>
                  <select
                    type="text"
                    className="form-control"
                    id="select-role"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    <option value="">Select Role</option>
                    <option value="reader">Reader</option>
                    <option value="writer">Writer</option>
                  </select>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!isValid || !role} // Disabled until valid email
                    onClick={() => handelSubmit("single")}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewDriveDetails;
